// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__30UbK","inner":"Footer_inner__3JYkW","nextIcon":"Footer_nextIcon__2YY7Q","innerLeft":"Footer_innerLeft__2dLyA"};